import React, { useState, useMemo, useEffect } from "react";
import { useUserContext } from "../../utils/UserContext";
import { tincPermis } from "../../utils/Permisos";
import SeleccionarAgenda from "./Seleccionaragenda";
import DetallsAgenda from "./Detallsagenda";
import CalendariAgenda from "./CalendariAgenda";
import AjudaAgenda from "./AjudaAgenda";
import "../dashboard_v2.css";
import "./agenda.css";
import "./seleccionaragenda.css";

function Agenda() {
  const [vista, setVista] = useState("llista");
  const [modeFitxa, setModeFitxa] = useState("consultar");
  const [selectedItem, setSelectedItem] = useState(null);
  const [filteredList, setFilteredList] = useState([]);
  const [mostraAjuda, setMostraAjuda] = useState(false);
  const [reloadToken, setReloadToken] = useState(0);

  const { rolUsuari, usuariActiu } = useUserContext();

  const [agFilterText, setAgFilterText] = useState("");
  const [agEstatFilter, setAgEstatFilter] = useState("pendents_encurs");
  const [agMostraAvisos, setAgMostraAvisos] = useState(true);
  const [agMostraTasques, setAgMostraTasques] = useState(true);
  const [agRelacio, setAgRelacio] = useState("assignades");
  const [agSelectedUsuari, setAgSelectedUsuari] = useState(null);

  useEffect(() => {
    if (agSelectedUsuari == null && usuariActiu) {
      setAgSelectedUsuari(usuariActiu);
    }
  }, [usuariActiu, agSelectedUsuari]);

  const handleSelect = (item) => {
    setSelectedItem((prev) => (prev && prev.idAgenda === item.idAgenda ? null : item));
  };

  const indexInList = useMemo(() => {
    if (!selectedItem) return -1;
    return filteredList.findIndex((x) => x.idAgenda === selectedItem.idAgenda);
  }, [filteredList, selectedItem]);

  const total = filteredList.length;
  const pos = indexInList >= 0 ? indexInList + 1 : null;

  const goPrev = () => {
    if (total <= 0 || indexInList < 0) return;
    const prevIdx = (indexInList - 1 + total) % total;
    setSelectedItem(filteredList[prevIdx]);
  };

  const goNext = () => {
    if (total <= 0 || indexInList < 0) return;
    const nextIdx = (indexInList + 1) % total;
    setSelectedItem(filteredList[nextIdx]);
  };

  const tornarLlista = () => {
    setVista("llista");
    setModeFitxa("consultar");
  };

  const obrirFitxa = (item, mode) => {
    setSelectedItem(item);
    setModeFitxa(mode);
    setVista("fitxa");
  };

  const obrirNou = () => {
    setSelectedItem(null);
    setModeFitxa("nou");
    setVista("fitxa");
  };

  const esLlista = vista === "llista";
  const esCalendari = vista === "calendari";

  const botoAjuda = (
    <button
      type="button"
      className="dv2-btn dv2-btn--icon dv2-btn--ghost"
      title="Com funciona l'Agenda"
      aria-label="Ajuda"
      onClick={() => setMostraAjuda(true)}
    >
      ?
    </button>
  );

  return (
    <div className="dv2 dv2-page dv2-page--fill">
      {mostraAjuda && <AjudaAgenda onTancar={() => setMostraAjuda(false)} />}

      {esLlista ? (
        <>
          <div className="dv2-pageHeader">
            <div className="dv2-pageHeader-main">
              <div className="dv2-pageHeader-icon" aria-hidden="true">
                🗓️
              </div>
              <div>
                <h1 className="dv2-pageHeader-title">Agenda</h1>
                <p className="dv2-pageHeader-subtitle">
                  Avisos (recados) i tasques assignades. El calendari només mostra el que tens a la safata.
                </p>
              </div>
            </div>
            <div className="dv2-pageHeader-actions">
              {tincPermis(rolUsuari, "CONSULTAR") && (
                <button type="button" className="dv2-btn" onClick={() => setVista("calendari")}>
                  Calendari
                </button>
              )}
              {tincPermis(rolUsuari, "CREAR") && (
                <button type="button" className="dv2-btn dv2-btn--primary" onClick={obrirNou}>
                  Nou
                </button>
              )}
              {botoAjuda}
            </div>
          </div>

          <SeleccionarAgenda
            onSelect={handleSelect}
            selectedItem={selectedItem}
            onDoubleConsult={(item) => obrirFitxa(item, "consultar")}
            onConsultar={(item) => obrirFitxa(item, "consultar")}
            onModificar={(item) => obrirFitxa(item, "modificar")}
            onEsborrar={(item) => obrirFitxa(item, "esborrar")}
            onItemsChange={(list) => setFilteredList(list || [])}
            reloadToken={reloadToken}
            filters={{
              filterText: agFilterText,
              setFilterText: setAgFilterText,
              estatFilter: agEstatFilter,
              setEstatFilter: setAgEstatFilter,
              mostraAvisos: agMostraAvisos,
              setMostraAvisos: setAgMostraAvisos,
              mostraTasques: agMostraTasques,
              setMostraTasques: setAgMostraTasques,
              relacio: agRelacio,
              setRelacio: setAgRelacio,
              selectedUsuari: agSelectedUsuari,
              setSelectedUsuari: setAgSelectedUsuari,
            }}
          />
        </>
      ) : esCalendari ? (
        <>
          <div className="dv2-pageHeader">
            <div className="dv2-pageHeader-main">
              <div className="dv2-pageHeader-icon" aria-hidden="true">
                🗓️
              </div>
              <div>
                <h1 className="dv2-pageHeader-title">Agenda · Calendari</h1>
                <p className="dv2-pageHeader-subtitle">
                  Només el que està assignat a l'usuari triat. Els filtres complets són a la llista.
                </p>
              </div>
            </div>
            <div className="dv2-pageHeader-actions">
              <button type="button" className="dv2-btn" onClick={tornarLlista}>
                Tornar
              </button>
              {botoAjuda}
            </div>
          </div>

          <CalendariAgenda
            onTornar={tornarLlista}
            onObrirAjuda={() => setMostraAjuda(true)}
            filters={{
              selectedUsuari: agSelectedUsuari,
              setSelectedUsuari: setAgSelectedUsuari,
              mostraAvisos: agMostraAvisos,
              setMostraAvisos: setAgMostraAvisos,
              mostraTasques: agMostraTasques,
              setMostraTasques: setAgMostraTasques,
            }}
          />
        </>
      ) : (
        <DetallsAgenda
          variant="page"
          mode={modeFitxa}
          item={modeFitxa === "nou" ? null : selectedItem}
          onCancel={tornarLlista}
          onObrirAjuda={() => setMostraAjuda(true)}
          onCanviarMode={(modeNou) => {
            setModeFitxa(modeNou);
            setVista("fitxa");
          }}
          onSave={(up) => {
            setSelectedItem(up?.deleted ? null : up);
            setReloadToken((n) => n + 1);
            if (up?.deleted || modeFitxa === "nou") {
              tornarLlista();
              return;
            }
            setModeFitxa("consultar");
          }}
          onPrev={modeFitxa === "consultar" ? goPrev : undefined}
          onNext={modeFitxa === "consultar" ? goNext : undefined}
          pos={modeFitxa === "consultar" ? pos : null}
          total={modeFitxa === "consultar" ? total : null}
        />
      )}
    </div>
  );
}

export default Agenda;
